import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { CopyAdviceProgressComponent } from './components/copy-advice-progress/copy-advice-progress.component';
import { CopyAdviceProgressDialogComponent } from './components/copy-advice-progress-dialog/copy-advice-progress-dialog.component';
import { CopyAdviceStatusComponent } from './components/copy-advice-status/copy-advice-status.component';
import { CopyAdviceEffects } from './store/copy-advice.effects';
import { reducer } from './store/copy-advice.reducer';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    CopyAdviceProgressDialogComponent,
    CopyAdviceProgressComponent,
    CopyAdviceStatusComponent,
  ],
  imports: [
    SharedModule,
    AgrDialogModule,
    MatProgressBarModule,
    MatIconModule,
    MatButtonModule,
  ],
  providers: [provideState('copyAdvice', reducer), provideEffects(CopyAdviceEffects)],
  exports: [CopyAdviceStatusComponent],
})
export class CopyAdviceModule {}
